import { createSelector } from 'reselect';
import { IUserState } from './types';

const selectUserState = (state: { userProfile: IUserState }) => state.userProfile;

export const selectUserProfile = createSelector(
  selectUserState,
  (userState) => userState.profile
);

export const selectUserPermissions = createSelector(
  selectUserState,
  (userState) => userState.permissions.data
);

export const selectPermissionsLoading = createSelector(
  selectUserState,
  (userState) => userState.permissions.loading
);

export const selectArePermissionsLoaded = createSelector(
  selectUserState,
  (userState) => userState.permissions.isLoaded
);

/**
 * Helper to check for a specific permission in a module
 * Usage: useSelector(selectHasPermission('worker-management', 'have_write'))
 */
export const selectHasPermission = (moduleSlug: string, permissionKey: 'have_read' | 'have_write' | 'have_edit' | 'have_delete' | 'have_admin') => 
  createSelector(
    selectUserPermissions,
    (permissions) => permissions[moduleSlug]?.[permissionKey] || false
  );